<h2 mat-dialog-title>Connect VRChat</h2>
<mat-dialog-content>
    <p>Please enter a link to your VRChat profile below. If you cannot find this link, you can enter your display name instead.</p>
    <mat-form-field style="width: 100%;">
        <mat-label>VRChat Profile Link</mat-label>
        <input matInput [formControl]="vrchatProfileLinkControl" />
        @if (vrchatProfileLinkControl.invalid && vrchatProfileLinkControl.touched) {
            <mat-error>{{ getErrorMessage() }}</mat-error>
        }
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <button style="width: fit-content;" mat-button mat-dialog-close>Cancel</button>
    <button style="width: fit-content;" mat-button (click)="connectVRChat()" [disabled]="vrchatProfileLinkControl.invalid || pending">Connect</button>
</mat-dialog-actions>